import { GET_EXPENSES_RESPONSE, GET_EXPENSE_DETAILS_RESPONSE, GET_MIMAR_PROFIT_RESPONSE } from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  expenseDetails: {},
  mimarProfit: {},
};

const expenses = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_EXPENSES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_EXPENSE_DETAILS_RESPONSE:
      return {
        ...state,
        expenseDetails: action.payload.expenseDetails,
      };
    case GET_MIMAR_PROFIT_RESPONSE:
      return {
        ...state,
        mimarProfit: action.payload.mimarProfit,
      };
    default:
      return state;
  }
};

export default expenses;
